<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="embed-responsive embed-responsive-21by9">
                <iframe (load)="onLoadding()" width="500" [height]="height()" [src]="dashboardUrl()" frameborder="0" style="border:0" allowfullscreen></iframe>
                <div *ngIf="isLoadding" [style.height.px]="height()"
                    style="position: relative; width: 10px; z-index: 1; float: right; background-color: #2a3042;">
                </div>
                <div *ngIf="isLoadding"
                    style="position: relative; width: 100%; height: 25px; z-index: 2; float: right; background-color: #2a3042;">
                </div>
            </div>
        </div>
    </div>
</div>